import {of as observableOf, Observable} from 'rxjs';

import {catchError} from 'rxjs/operators';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import {DetailControl, ValuesObject} from '../detail-tabconfig';
import {ViewTabComponent} from '../viewtab.component';
import {ControlNameNotFound} from '../../../error/errordefinitions';

@Component({
  selector: 'ctrl-captioncontrol',
  template: ` <h4>{{ (captionObs | async)?.Values }}</h4> `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CtrlCaptionControlComponent {
  constructor(
    private _parent: ViewTabComponent,
    private changeDetector: ChangeDetectorRef,
  ) {}

  captionObs: Observable<ValuesObject<string>> = observableOf(new ValuesObject(''));

  value: Observable<string> = observableOf('');
  _config: DetailControl = null;

  @Input()
  set config(conf: DetailControl) {
    if (conf != this._config && conf != null) {
      this._config = conf;
      if (conf.Caption != null) {
        this.captionObs = conf.Caption.pipe(
          catchError((error, caught) => this.handleError(error, caught)),
        );
        this.changeDetector.markForCheck();
      }
    }
  }

  handleError(error: any, caught?: Observable<any>) {
    if (this._config != null) {
      this._config.hasErrors = true;
    }
    if (error.name != ControlNameNotFound.name) {
      this._config.Name.pipe(
        catchError((error, caught) => this.handleError(new ControlNameNotFound(), caught)),
      ).subscribe(name => {
        if (this._parent != null) {
          if (name != null && name.Values != null) {
            this._parent.addControlError(name.Values, String(error.message));
          } else {
            this._parent.addControlError('Unknown Control', String(error.message));
          }
        }
      });
    } else {
      if (this._parent != null) {
        this._parent.addControlError('Unknown Control', String(error.message));
      }
    }
    console.error(error);

    return observableOf(null);
  }
}
